<template>
  <div :class="disabled ? 'disabled' : ''" class="checkbox">
    <label class="d-flex gap-2 align-items-center mt-1">
      <input
        :id="id ?? name"
        type="radio"
        :value="value"
        :name="name"
        :checked="checked"
        :required="required"
        :class="options?.image ? 'invisible' : ''"
        :disabled="disabled"
        @click="$emit('update:data', $event.target.value)"
      />
      <div class="check rounded-4 fs-5" :class="options?.image ? 'd-none' : ''"></div>
      <img v-if="options?.image" :src="options.image" class="w-100" />
      <span v-if="!options?.image">{{ label }}</span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    disabled: { type: Boolean, default: false },
    id: { type: String, default: '' },
    label: { type: String, default: '' },
    name: { type: String, default: '' },
    value: { type: [String, Number, Array], default: '' },
    checked: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    options: { type: Object, default: () => {} },
  },
  emits: ['update:data'],
  setup() {
    return {};
  },
};
</script>
